import { InfluencerReportTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "../UiActions";

// ----------------------------------------------------------------------

export const InfluencerReportActions = {};

// THUNKS
// ----------------------------------------------------------------------
InfluencerReportActions.get = (startDate, endDate, callback) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(InfluencerReportActions.start());

    let queueId = "InfluencerReport-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.InfluencerReport.get,
      Object.assign({}, {
        startDate,
        endDate
      }),
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(InfluencerReportActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {

          dispatch(InfluencerReportActions.success(true));

          dispatch(InfluencerReportActions.set(result));
        } else {
          dispatch(
            InfluencerReportActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
        }

        if (callback) {
          callback(response);
        }
      }
    );
  };
};


InfluencerReportActions.start = () => {
  return (dispatch) => {
    dispatch(InfluencerReportActions.pending(true));
    dispatch(InfluencerReportActions.success(false));
    dispatch(InfluencerReportActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

InfluencerReportActions.sync = () => ({
  payment: {
    lastSync: Date.now()
  },
  type: InfluencerReportTypes.sync
});

InfluencerReportActions.set = (payment) => ({
  payment: {
    data: payment,
    lastSync: Date.now()
  },
  type: InfluencerReportTypes.set
});

InfluencerReportActions.unset = () => ({
  payment: InitialState.createSyncObject(),
  type: InfluencerReportTypes.unset
});

InfluencerReportActions.success = (success) => ({
  payment: {
    success: (success === true)
  },
  type: InfluencerReportTypes.success
});

InfluencerReportActions.pending = (pending) => ({
  payment: {
    pending: (pending === true)
  },
  type: InfluencerReportTypes.pending
});

InfluencerReportActions.error = (error) => ({
  payment: {
    error
  },
  type: InfluencerReportTypes.error
});
